import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { motion } from "framer-motion";
import axios from "axios";
import { BACKEND_URL, API } from "@/lib/api";


export default function AuthCallback({ onLoginSuccess }) {
  const [searchParams] = useSearchParams();
  const [status, setStatus] = useState("processing");
  const [message, setMessage] = useState("Anmeldung wird verarbeitet...");
  const [logoUrl, setLogoUrl] = useState(null);

  useEffect(() => {
    // Fetch logo
    const fetchLogo = async () => {
      try {
        const response = await axios.get(`${API}/branding/logo`);
        if (response.data.logo_url) {
          setLogoUrl(`${BACKEND_URL}${response.data.logo_url}`);
        }
      } catch {
        // Use default logo
      }
    };
    fetchLogo();
  }, []);

  useEffect(() => {
    const token = searchParams.get("token");
    const redirect = searchParams.get("redirect") || "/dashboard";
    const error = searchParams.get("error");

    console.log("AuthCallback: token received:", token ? "yes" : "no");
    console.log("AuthCallback: redirect to:", redirect);

    if (error) {
      setStatus("error");
      setMessage("Anmeldung fehlgeschlagen. Bitte versuche es erneut.");
      setTimeout(() => {
        window.location.href = "/login?error=" + error;
      }, 2000);
      return;
    }

    if (token) {
      console.log("AuthCallback: Token received, length:", token.length);
      console.log("AuthCallback: Token preview:", token.substring(0, 50) + "...");

      // Store token in localStorage
      localStorage.setItem("auth_token", token);
      console.log("AuthCallback: token saved to localStorage");

      // Verify it was saved
      const savedToken = localStorage.getItem("auth_token");
      console.log("AuthCallback: Verification - token in localStorage:", savedToken ? "YES" : "NO");

      // Decode token to get user info (basic JWT decode)
      try {
        const payload = JSON.parse(atob(token.split('.')[1]));
        console.log("AuthCallback: Token decoded successfully");
        console.log("AuthCallback: Payload user_id:", payload.user_id);
        console.log("AuthCallback: Payload email:", payload.email);

        const user = {
          id: payload.user_id,
          email: payload.email,
          name: payload.name,
          picture: payload.picture
        };

        // Store user info
        localStorage.setItem("user", JSON.stringify(user));
        console.log("AuthCallback: user saved:", user.email);

        setStatus("success");
        setMessage("Anmeldung erfolgreich! Weiterleitung...");

        // Use window.location.href for a full page reload to ensure token is picked up
        setTimeout(() => {
          console.log("AuthCallback: redirecting to", redirect);
          console.log("AuthCallback: Final localStorage check - auth_token:", localStorage.getItem("auth_token") ? "EXISTS" : "MISSING");
          window.location.href = redirect;
        }, 1500);
      } catch (e) {
        console.error("Token decode error:", e);
        console.error("Token that failed to decode:", token);
        setStatus("error");
        setMessage("Token-Fehler. Bitte erneut anmelden.");
        setTimeout(() => {
          window.location.href = "/login";
        }, 2000);
      }
    } else {
      setStatus("error");
      setMessage("Kein Token erhalten. Bitte erneut anmelden.");
      setTimeout(() => {
        window.location.href = "/login";
      }, 2000);
    }
  }, [searchParams]);

  return (
    <div className="min-h-screen bg-gradient-to-br from-[#f5f0e8] via-white to-[#e8f0f5] flex items-center justify-center p-4">
      <motion.div
        initial={{ opacity: 0, scale: 0.9 }}
        animate={{ opacity: 1, scale: 1 }}
        className="bg-white rounded-2xl shadow-xl p-8 max-w-sm w-full text-center"
      >
        {/* Status Icon */}
        <div className="mb-6">
          {status === "processing" && (
            <div className="w-16 h-16 mx-auto border-4 border-primary border-t-transparent rounded-full animate-spin" />
          )}
          {status === "success" && (
            <motion.div
              initial={{ scale: 0 }}
              animate={{ scale: 1 }}
              className="w-16 h-16 mx-auto bg-green-500 rounded-full flex items-center justify-center"
            >
              <svg className="w-8 h-8 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={3} d="M5 13l4 4L19 7" />
              </svg>
            </motion.div>
          )}
          {status === "error" && (
            <motion.div
              initial={{ scale: 0 }}
              animate={{ scale: 1 }}
              className="w-16 h-16 mx-auto bg-red-500 rounded-full flex items-center justify-center"
            >
              <svg className="w-8 h-8 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={3} d="M6 18L18 6M6 6l12 12" />
              </svg>
            </motion.div>
          )}
        </div>

        {/* Message */}
        <h2 className="text-xl font-serif text-gray-800 mb-2">
          {status === "processing" && "Einen Moment..."}
          {status === "success" && "Willkommen!"}
          {status === "error" && "Fehler"}
        </h2>
        <p className="text-gray-500">{message}</p>

        {/* Logo */}
        <div className="mt-8 pt-6 border-t border-gray-100">
          <img
            src={logoUrl || "/assets/moki-logo.svg"}
            alt="Mokiplaner"
            className="h-7 mx-auto opacity-50"
            onError={(e) => {
              e.target.style.display = 'none';
            }}
          />
        </div>
      </motion.div>
    </div>
  );
}
